var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b',{staticClass:"require_star",attrs:{"title":"必填项"}})
}
var staticRenderFns = []

export { render, staticRenderFns }